// extracted by css-extract-rspack-plugin
export default {"skeleton":"Skeleton-module__skeleton","pulse":"Skeleton-module__pulse","addBorderRadius":"Skeleton-module__addBorderRadius"};